import { sortByField } from '../../utils/arrObj';
import { dynamicTypes } from './fields';
import { clone, path } from 'ramda';
import { convertPercentsToCol } from '../../helpers/woGrid';

export function prepareDynamicList(list) {
  let sortedList = sortByField(list);

  // Filter enabled
  for (let i = sortedList.length; i--;) {
    if (sortedList[i].enabled && sortedList[i].enabled == 0) {
      sortedList.splice(i, 1);
    }
  }

  return sortedList;
}

function _buildOptionsFromString(str) {
  const arr = [];
  if (str && str.length > 0) {
    const data = str.split(';');
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i] && data[i].length > 0) {
          arr.push({
            value: data[i],
            text: data[i],
          });
        }
      }
    }
  }

  return arr;
}

function _setUpFields(data, template) {
  if (data && template) {
    // Set label
    template.label = data.label || '';
    if (data.label) {
      template.rules.title = data.label + ' field';
    } else {
      template.rules.title = '';
    }
    // Set Name
    if (data.id) {
      template.system.name = data.id;
    }
    // Set grid
    if (data.options && data.options.width && template.style) {
      template.style.grid = convertPercentsToCol(data.options.width);
    }
    // Set source for dropdowns
    if (data.component == 'dropdown' && data.options && data.options.option) {
      template.source = _buildOptionsFromString(data.options.option);
    }
  }
  return template;
}

export function createListOfFields(list) {
  let arrFields = [];

  for (let i = 0; i < list.length; i++) {
    if (list[i].enabled === 0) {
      continue;
    }
    if (list[i] && list[i].component && list[i].component.length > 0) {
      // Doesn't support links for now
      if (list[i].component.indexOf('link') !== -1) {
        continue;
      }

      if (dynamicTypes.hasOwnProperty(list[i].component)) {
        // Set component based on types from options
        if (list[i].options && list[i].options.type) {
          if (list[i].options.type == 'Date picker') {
            list[i].component = 'datepicker';
          }
        }
        let template = clone(dynamicTypes[list[i].component]);
        let field = _setUpFields(list[i], template);
        if(list[i].isRequired === 1 && list[i].type === 'custom_field'){
          field.rules.required = true;
        }
        // Add field
        arrFields[parseInt(list[i].order)] = field;
      }
    }
  }

  return arrFields;
}

function _convertValue(val) {
  return val.toString();
}

function _buildData(fields, dynamicFields) {
  const data = {};

  // Process Dynamic Fields
  for (let i = 0; i < dynamicFields.length; i++) {
    let currentField = dynamicFields[i];

    if (currentField && currentField.system && currentField.system.name) {
      data[currentField.system.name] = _convertValue(currentField.value) || '';
    }
  }

  // Process static fields
  const workOrder = path(['workOrder', 'value'], fields);

  if (workOrder) {
    data[1] = workOrder;
  }

  return data;
}

function _buildPl(suppliesLog) {
  const pl = {};

  if (suppliesLog && suppliesLog.length > 0) {
    for (let i = 0; i < suppliesLog.length; i++) {
      let currentForm = suppliesLog[i];
      if (currentForm) {
        let id = currentForm.id;
        let name = path(['vendorName', 'value'], currentForm);
        let email = path(['vendorEmail', 'value'], currentForm);
        pl['pl-form-' + id] = {
          email,
          paint: {
            '1': name,
          },
        };
      }
    }
  }

  return pl;
}

export function customProcessFields(fields, dynamicFields, suppliesLog, materialsData, suppliesDataV2) {
  const customerId = path(['customer', 'value'], fields) || 0;
  const stageId = path(['status', 'value'], fields) || 0;
  const projectId = path(['project', 'value'], fields) || 0;
  const contacts = path(['contacts', 'value'], fields) || 0;
  const salesRepId = path(['salesRep', 'value'], fields) || 0;
  const post = {
    data: JSON.stringify(_buildData(fields, dynamicFields)),
    project_id: parseInt(customerId),
    contacts: contacts || [],
    sales_rep_id: parseInt(salesRepId),
    lane_id: parseInt(projectId),
    stage_id: parseInt(stageId),
    board_id: 1,
    pl: JSON.stringify(suppliesLog),
    vte: '',
    pl_d: '',
    materials: materialsData.filter((item) => Boolean(item.name)).map((item) => ({
      name: item.name,
      material_id: item.material_id,
      price: Number(item.price.replace(',', '')).toFixed(2).toString(),
      quantity: Number(item.quantity).toString(),
      unit_of_measure: item.unit_of_measure,
      subtotal: Number(item.subtotal).toFixed(2).toString(),
    })),
    supplies_log: suppliesDataV2.filter((item) => Boolean(item.vendor)).map((item) => ({
      frontend_suplog_id: item.frontend_suplog_id,
      vendor_id: item.vendor,
      comment: item.comments,
      materials: item.materials.filter((matItem) => Boolean(matItem.name)).map((matItem) => ({
        name: matItem.name,
        material_id: matItem.material_id,
        price: Number(matItem.price.replace(',', '')).toFixed(2).toString(),
        quantity: Number(matItem.quantity).toString(),
        subtotal: Number(matItem.subtotal).toFixed(2).toString(),
      })),
    })),
  };

  return post;
}



// WEBPACK FOOTER //
// ./src/containers/WorkOrderAdd/data.js